import { ComponentStyleConfig } from '@chakra-ui/react'

export default <ComponentStyleConfig>{
  baseStyle: {
    tab: {
      _focus: { boxShadow: 'none' },
    },
  },
}
